<template>
	<v-dialog
		v-model="showDialog"
		max-width="800px"
		persistent
		content-class="manage-field-dialog"
		scrollable
	>
		<v-card>
			<v-card-title>Assign Projects</v-card-title>
			<v-card-text class="pa-0 mt-6">
				<div class="field-lists-container d-flex" style="height: 100%">
					<div class="col-5 hidden-list">
						<v-list dense>
							<v-subheader>Unassigned projects</v-subheader>
							<v-list-item-group
								v-model="selectedUnassigned"
								active-class="primary white--text"
								class="field-list"
								multiple
							>
								<v-list-item
									v-for="item in unassigned"
									:key="item.Id"
									:value="Object(item)"
								>
									<v-list-item-content>
										<v-list-item-title>{{
											item.Name
										}}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</div>
					<div class="d-flex flex-column justify-center col-2">
						<v-btn
							class="my-2"
							color="primary"
							outlined
							text
							@click="assignProject()"
						>
							<v-icon> mdi-arrow-right </v-icon>
						</v-btn>
						<v-btn
							class="my-2"
							color="primary"
							outlined
							text
							@click="unassignProject()"
						>
							<v-icon> mdi-arrow-left </v-icon>
						</v-btn>
					</div>
					<div class="col-5 visible-list">
						<v-list dense>
							<v-subheader>Assigned projects</v-subheader>
							<v-list-item-group
								v-model="selectedAssigned"
								active-class="primary white--text"
								class="field-list"
								multiple
							>
								<v-list-item
									v-for="item in assigned"
									:key="item.Id"
									:value="Object(item)"
									class="px-1"
								>
									<v-list-item-content>
										<v-list-item-title>
											{{ item.Name }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</div>
				</div>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click="onCancel()"> Done </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { UserProjectGetters } from '../../../store/getters';
import { UserProjectActions } from '../../../store/actions';
import { UserProjectPermissionActions } from '../../../store/actions';
import { mapGetters } from 'vuex';
import { GeneralActions } from '../../../store/actions';
// import userProject from '../../../store/modules/clientContext/userManagement/clientUserManagement/userProject';
export default {
	name: 'UserProjectAssignment',
	props: {
		showDialog: Boolean,
	},
	computed: {
		...mapGetters({
			assigned: [UserProjectGetters.ASSIGNEDPROJECTS],
			unassigned: [UserProjectGetters.UNASSIGNEDPROJECTS],
			loading: [UserProjectGetters.IS_LOADING],
		}),
	},
	data() {
		return {
			selectedUnassigned: [],
			selectedAssigned: [],
		};
	},
	mounted() {
		this.loadData();
	},
	methods: {
		assignProject() {
			this.$store.dispatch(GeneralActions.LOADING, true);
			this.$store
				.dispatch(UserProjectActions.INSERT_USERPROJECTS, {
					userId: this.$route.params.id,
					projects: this.selectedUnassigned,
				})
				.then(() => {
					this.$store
						.dispatch(GeneralActions.LOADING, false)
						.then(() => {
							this.loadData();
						});
				})
				.then(() => {
					(this.selectedUnassigned = []),
						(this.selectedAssigned = []);
				});
		},
		unassignProject() {
			this.$store.dispatch(GeneralActions.LOADING, true);
			this.$store
				.dispatch(UserProjectActions.DELETE_USERPROJECTS, {
					userId: this.$route.params.id,
					projects: this.selectedAssigned,
				})
				.then(() => {
					this.$store
						.dispatch(GeneralActions.LOADING, false)
						.then(() => {
							this.loadData();
						});
				})
				.then(() => {
					(this.selectedUnassigned = []),
						(this.selectedAssigned = []);
				});
		},
		onCancel() {
			this.$emit('cancel');
		},
		onSubmit() {
			this.$emit('cancel');
		},
		loadData() {
			this.$store.dispatch(
				UserProjectActions.LOAD,
				this.$route.params.id
			);
			this.$store.dispatch(
				UserProjectPermissionActions.LOAD_USERPROJECTS,
				this.$route.params.id
			);
		},
	},
};
</script>
